import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "../../assets/css/slick.css";
import "../../assets/css/slick-theme.css";
// import getClientLogo from "./ClientLogoData.json";
import { ClientLogoCarouselConfig } from "../../includes/scripts";
import axios from "axios";

const ClientLogo = () => {
  const [homeWeAre, setHomeWeAre] = useState(null);
  // console.log("employees", homeWeAre);
  const fetchHomeWeare = async () => {
    try {
      const response = await axios.get(
        "https://rss.fastwebforge.com/api/list/our-logo"
      );
      setHomeWeAre(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchHomeWeare();
  }, []);

  let heroSection = null;
  if (homeWeAre && homeWeAre.data && homeWeAre.data) {
    heroSection = homeWeAre.data;
  }

//   console.log(" Datalogo:", heroSection);

  return (
    <>
      <div className="all-patner-sec">
        <div className="all-patner">
          <div className="container">
            <Slider {...ClientLogoCarouselConfig}>
              

              {heroSection
                ? heroSection &&
                  heroSection.map((data, i) => (
                    <div key={i} className="">
                      <div className="single-patner">
                    <img
                      src={data.thumbnail}
                      alt="logo"
                    />
                  </div>
                    </div>
                  ))
                : null}
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClientLogo;
